import type { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

/** Inline spinner or value for KPI numbers (e.g. while refetching). */
export function StatNumber({
  loading,
  children,
  className,
  spinnerClassName,
}: {
  loading?: boolean;
  children: ReactNode;
  className?: string;
  /** Defaults to a sensible spinner size; falls back to `className` if omitted. */
  spinnerClassName?: string;
}) {
  if (loading) {
    return (
      <Loader2
        className={cn(
          'h-8 w-8 animate-spin text-muted-foreground',
          spinnerClassName ?? className
        )}
        aria-hidden
      />
    );
  }
  return <span className={className}>{children}</span>;
}

/** Pulse skeleton row for stat / KPI cards. */
export function StatsGridSkeleton({
  count = 4,
  className,
}: {
  count?: number;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6',
        className
      )}
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="rounded-lg border border-border bg-card p-6 animate-pulse"
        >
          <div className="h-4 w-28 bg-muted rounded mb-4" />
          <div className="h-9 w-20 bg-muted rounded" />
        </div>
      ))}
    </div>
  );
}
